module.exports = __webpack_public_path__ + "static/media/facebookblue.89bffd26.svg";